/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import { useEffect, useState, React } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Swal from 'sweetalert2';

import 'swiper/css';
import 'swiper/css/navigation';
import LGPD from '../components/LGPD';
import ModalVotacao from '../components/ModalVotacao';
import PizzariaDetalhes from '../components/PizzariaDetalhes';
import Regulamento from '../components/Regulamento';
import TermosDeUso from '../components/TermosDeUso';
import { useGlobal } from '../contexts/global';

import { buscaPizzarias } from '../services/Votacao';

import '../assets/scss/Home.scss';

import bannerPizza from '../assets/images/home/banner-pizza.webp';
import bannerPatrocinador2026 from '../assets/images/home/banner-patrocinador-2026.webp';
import iconStep1 from '../assets/images/home/fase-1.png';
import iconStep2 from '../assets/images/home/fase-2.png';
import iconStepAward from '../assets/images/home/fase-3.png';
import iconFatiaPizza from '../assets/images/home/fatia-pizza.png';
import folha from '../assets/images/home/folha.png';
import bgSpPizza from '../assets/images/home/hero-bg-image.png';
import iconCalendar from '../assets/images/icons/calendar-white.svg';
import imageFlip from '../assets/images/image_flip.png';
import logoBranco2026 from '../assets/images/logo/branco-transparente.webp';
import logoCor2026 from '../assets/images/logo/cor-transparente-com-texto.webp';
import logoOlivasDigital from '../assets/images/logo_olivas_digital.png';

import logoApubraBranco from '../assets/images/logo_apubra_white.svg';
import logoSupremaVermelho from '../assets/images/Suprema.svg';
import logoSupremaBranco from '../assets/images/Suprema_branco.svg';
import logoZahilBranco from '../assets/images/zahil_logo_branco.svg';
import logoAbraselBranco from '../assets/images/abrasel-branco.png';
import logoBaresSPBranco from '../assets/images/baressp-branco.png';
import logoBandFmBranco from '../assets/images/band-fm-branco.png';
import logoConPizzaBranco from '../assets/images/con-pizza-branco.png';

import imageCalabresa from '../assets/images/calabresa.png';
import imageDelivery from '../assets/images/delivery.webp';
import imageMarguerita from '../assets/images/marguerita.png';
import imagePortuguesa from '../assets/images/portuguesa.png';
import { getAllPosts, getSinglePost } from '../services/LoadInstagram';

import imageCasteloes from '../assets/images/vencedores/casteloes.jpg';
import imageChena from '../assets/images/vencedores/chena.jpg';
import imageGalpaozin from '../assets/images/vencedores/galpaozin.jpg';
import imageGattoffiga from '../assets/images/vencedores/gattoffiga.png';
import imageJullia from '../assets/images/vencedores/jullia.jpg';
import imageKrostinas from '../assets/images/vencedores/krostinas.jpg';
import imageMercutio from '../assets/images/vencedores/mercutio.jpg';
import imageNapoli from '../assets/images/vencedores/napoli.jpg';
import imageOli from '../assets/images/vencedores/oli-pizzas.jpg';
import imageQuintalVoMaria from '../assets/images/vencedores/quintal-vo-maria.jpg';
import imageRemanso from '../assets/images/vencedores/remanso.webp';
import imageRRBrasil from '../assets/images/vencedores/rrbrasil.jpg';
import imageSperanza from '../assets/images/vencedores/speranza.jpg';
import imageVaranda from '../assets/images/vencedores/varanda.jpg';
import imageVeridiana from '../assets/images/vencedores/veridiana.jpg';

const Home = () => {
  const fase = String(process.env.REACT_APP_FASE);
  const dayCounter = 30 - new Date().getDate();
  const location = useLocation();
  const history = useHistory();
  const [pizzarias, setPizzarias] = useState({});
  const [instagramItems, setInstagramItems] = useState([]);
  const {
    success,
    setSuccess,
    error,
    setError,
    showModalVotacao,
    setShowModalVotacao,
    setIdPizzaria,
    setNomePizzaria,
    showRegulamento,
    setShowRegulamento,
    zonaAtual,
    setZonaAtual
  } = useGlobal();

  const tab = {
    regiao_central: 'REGIÃO CENTRAL',
    leste: 'ZONA LESTE',
    norte: 'ZONA NORTE',
    oeste: 'ZONA OESTE',
    sul: 'ZONA SUL'
  };

  const scroll = () => {
    document.getElementById('bt-votar').style.display = 'none';
    document
      .getElementById('section-votacao')
      .scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const scrollResultados = () => {
    const resultadosSection = document.getElementById('vencedores');
    if (resultadosSection) {
      resultadosSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const showVotacao = (id, nome, zona) => {
    setIdPizzaria(id);
    setNomePizzaria(nome);
    setZonaAtual(zona);
    setShowModalVotacao(true);
  };

  useEffect(() => {
    let unmounted = false;
    setZonaAtual(tab.regiao_central);
    const laodPizzarias = async () => {
      const resp = await buscaPizzarias();
      if (!unmounted) {
        setPizzarias(resp);
      }
    };

    laodPizzarias();

    if (success) {
      Swal.fire({
        timer: 2500,
        icon: 'success',
        showConfirmButton: false,
        html: '<p class="in-home-modal-title">Seu voto foi confirmado com sucesso. Obrigado!</p>',
        didClose: () => {
          setSuccess(false);
          setError(false);
          history.push('/');
        }
      });
    }

    if (error) {
      Swal.fire({
        timer: 2500,
        icon: 'error',
        showConfirmButton: false,
        text: 'Você já votou nesta categoria!',
        didClose: () => {
          setSuccess(false);
          setError(false);
        }
      });
    }

    return () => {
      unmounted = true;
    };
  }, []);

  const [isPopupOpen, setPopupOpen] = useState(true);

  const closePopup = () => {
    setPopupOpen(false);
  };

  useEffect(() => {
    const proximaZonaKey = localStorage.getItem('proxima_zona');
    if (proximaZonaKey) {
      setTimeout(() => {
        const pizzariasElement = document.getElementById('pizzarias');
        if (pizzariasElement) {
          pizzariasElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500);

      setTimeout(() => {
        const tabElement = document.querySelector(
          `[data-tab-key="${proximaZonaKey}"]`
        );
        if (tabElement) {
          tabElement.click();
        }
      }, 500);

      localStorage.removeItem('proxima_zona');
    }
  }, [history]);

  useEffect(() => {
    const fetchInstagramPosts = async () => {
      try {
        const allPosts = await getAllPosts();
        const firstEightPosts = allPosts.slice(0, 8);

        const postPromises = firstEightPosts.map((post) =>
          getSinglePost(post.id)
        );
        const results = await Promise.all(postPromises);

        setInstagramItems(results);
      } catch (err) {
        // console.error('Erro ao buscar posts do Instagram:', err);
      }
    };

    fetchInstagramPosts();
  }, []);

  return (
    <>
      {/* Modais */}
      {location.pathname === '/termos-de-uso' && <TermosDeUso />}
      {location.pathname === '/lgpd' && <LGPD />}
      {location.pathname.split('/')[1] === 'pizzaria' && <PizzariaDetalhes />}
      {showModalVotacao && <ModalVotacao />}
      {showRegulamento && <Regulamento />}

      {/* Home */}
      <section>
        {(fase === '1' || fase === '2') && (
          <section className="in-votenow" id="bt-votar">
            <span onClick={scroll}>Vote agora!</span>
          </section>
        )}
        <section className="in-init">
          {/* FASE 1 encerrada modal */}
          {/* <Popup isOpen={isPopupOpen} onClose={closePopup} /> */}
          <div className="in-init-bg">
            <img src={bgSpPizza} alt={bgSpPizza} />
          </div>
          <div className="in-init-ctn">
            <div className="in-init-ctn-grid">
              <div className="in-init-ctn-grid-logo">
                <img src={logoBranco2026} alt={logoBranco2026} />
              </div>

              <div className="in-init-ctn-grid-info">
                <div className="in-init-ctn-grid-info-title">
                  <h1>
                    EM BUSCA DAS MELHORES
                    <br />
                    PIZZAS DA CIDADE
                  </h1>
                </div>
                <div className="in-init-ctn-grid-info-subtitle">
                  <p>
                    São Paulo é uma das capitais mundiais da Pizza. Artesanal,
                    brotinho, tamanho família, meio a meio: não importa o sabor,
                    o formato ou o tipo, as pizzarias são um patrimônio da
                    gastronomia paulistana. Por isso, chegou a hora de saber:
                    quais são as pizzarias que fazem as melhores pizzas de
                    Calabresa, Marguerita e Portuguesa da cidade?
                    <br />
                    <br />É você, paulistana e paulistano, quem decide!
                  </p>
                </div>
                {(fase === '1' || fase === '2') && (
                  <>
                    <div
                      onClick={scroll}
                      className="in-init-ctn-grid-info-votenow"
                    >
                      <p>Vote agora!</p>
                    </div>
                    {/* <div className="in-init-ctn-grid-info-daycounter">
                      <h1>
                        FALTA{dayCounter > 1 ? 'M' : ''}{' '}
                        <span>
                          {dayCounter} DIA{dayCounter > 1 ? 's' : ''}
                        </span>
                      </h1>
                    </div> */}
                  </>
                )}
              </div>

              <div className="sponsors-wrapper">
                <div className="secao-patrocinio">
                  <p>PATROCÍNIO</p>
                  <a
                    href="https://loja.bungeprofissional.com.br/sp8-2026?utm_source=trade-patrocinio&utm_medium=cpc&utm_campaign=trade-patrocinio-sp82026"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <img src={logoSupremaBranco} alt="Logo Suprema" />
                  </a>
                </div>

                <div className="secao-patrocinio">
                  <p>APOIO</p>
                  <div className="patrocinio-grid">
                    <a
                      href="https://sp.abrasel.com.br/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <img src={logoAbraselBranco} alt="Logo Abrasel" />
                    </a>

                    <a
                      href="https://www.instagram.com/institutoconpizza/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <img src={logoConPizzaBranco} alt="Logo Con Pizza" />
                    </a>
                  </div>
                </div>

                <div className="secao-patrocinio">
                  <p>PARCERIA DE MÍDIA</p>
                  <div className="patrocinio-grid">
                    <a
                      href="https://www.baressp.com.br/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <img src={logoBaresSPBranco} alt="Logo Bares SP" style={{ padding: '0 40px' }} />
                    </a>

                    <a
                      href="https://www.band.com.br/bandnews-fm"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <img src={logoBandFmBranco} alt="Logo Band FM" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="in-contest">
          <div className="in-contest-ctn">
            <div className="in-contest-ctn-grid">
              <div className="in-contest-ctn-grid-sup">
                <p className="title">O concurso</p>

                <p className="description">
                  O SP8 Pizza é a única premiação aberta à participação de todas
                  as pizzarias de todos os bairros e regiões da cidade de São
                  Paulo. São duas fases:
                  <br />
                  <br />
                  Na 1ª fase, somente aqui nesta plataforma digital, você vai
                  ajudar a eleger a Melhor Pizzaria da cidade, a Melhor Pizza de
                  Delivery e as pizzarias que fazem a Melhor Pizza Marguerita, a
                  Melhor Pizza de Calabresa e a Melhor Pizza Portuguesa.
                  <br />
                  <br />
                  Na 2ª fase, com voto popular aqui nesta plataforma digital, e
                  também com o voto de um júri técnico, serão eleitas a melhor
                  pizzaria de cada região: Zonas Norte, Sul, Leste, Oeste e
                  Centro.
                </p>
              </div>

              {/* fases da votação */}
              <div className="in-contest-ctn-grid-sub">
                <div className="in-contest-ctn-grid-sub-step">
                  {(fase === '2' ||
                    fase === '1-encerrada' ||
                    fase === '2-encerrada' ||
                    fase === '3') && (
                      <div className="in-contest-ctn-grid-sub-step-container-strip">
                        <div className="in-contest-ctn-grid-sub-step-strip">
                          <h3>Fase encerrada!</h3>
                        </div>
                      </div>
                    )}
                  <div className="in-contest-ctn-grid-sub-step-image">
                    <img src={iconStep1} alt="" />
                  </div>

                  <div className="in-contest-ctn-grid-sub-step-list">
                    <p className="title-card">Melhor pizza</p>

                    <p className="single-text-card with-margin">
                      Você pode votar em qualquer pizzaria de São Paulo para
                      escolher:
                    </p>

                    <ul>
                      <li>
                        <p className="single-text-card">
                          <span>›</span> Melhor Pizza de Calabresa
                        </p>
                      </li>
                      <li>
                        <p className="single-text-card">
                          <span>›</span> Melhor Pizza Marguerita
                        </p>
                      </li>
                      <li>
                        <p className="single-text-card">
                          <span>›</span> Melhor Pizza Portuguesa
                        </p>
                      </li>
                      <li>
                        <p className="single-text-card">
                          <span>›</span> Melhor Pizza Delivery
                        </p>
                      </li>
                      <li>
                        <p className="single-text-card">
                          <span>›</span> Melhor Pizzaria de São Paulo
                        </p>
                      </li>
                    </ul>

                    <button type="button">
                      <img src={iconCalendar} alt={iconCalendar} />
                      <span>de 03/06 até 15/06</span>
                    </button>
                  </div>
                </div>

                <div className="in-contest-ctn-grid-sub-step">
                  {(fase === '2-encerrada' || fase === '3') && (
                    <div className="in-contest-ctn-grid-sub-step-container-strip">
                      <div className="in-contest-ctn-grid-sub-step-strip">
                        <h3>Fase encerrada!</h3>
                      </div>
                    </div>
                  )}

                  <div className="in-contest-ctn-grid-sub-step-image">
                    <img src={iconStep2} alt="" />
                  </div>

                  <div className="in-contest-ctn-grid-sub-step-list">
                    <p className="title-card">MELHOR PIZZARIA DE CADA REGIÃO</p>

                    <ul>
                      <li>
                        <p className="single-text-card">
                          <span>› </span>
                          Vamos selecionar as 3 pizzarias mais votadas em cada
                          região na Fase 1
                        </p>
                      </li>
                      <li>
                        <p className="single-text-card">
                          <span>› </span>O público vota na melhor de cada região
                          aqui no site sp8pizza.com.br
                        </p>
                      </li>
                      <li>
                        <p className="single-text-card">
                          <span>› </span>Um júri técnico visita de maneira
                          incógnita as finalistas e vota na melhor de cada
                          região
                        </p>
                      </li>
                      <li>
                        <p className="single-text-card">
                          <span>› </span>O resultado considera peso de 50% para
                          o voto popular e 50% para o voto do júri
                        </p>
                      </li>
                    </ul>

                    <button type="button">
                      <img src={iconCalendar} alt={iconCalendar} />
                      <span>de 19/06 até 29/06</span>
                    </button>
                  </div>
                </div>

                <div className="in-contest-ctn-grid-sub-step">
                  <div className="in-contest-ctn-grid-sub-step-image">
                    <img src={iconStepAward} alt="" />
                  </div>

                  <div className="in-contest-ctn-grid-sub-step-award">
                    <p className="title-card">Festa da pizza</p>

                    <p>
                      As pizzarias vencedoras serão conhecidas durante a “Festa
                      da Pizza”, evento aberto ao público no Museu da Imigração,
                      no dia 4 de julho de 2026.
                    </p>

                    <button type="button" onClick={scrollResultados}>
                      <img src={iconCalendar} alt={iconCalendar} />
                      <span>04/07</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section-banner-patrocinador">
          <a
            href="https://loja.bungeprofissional.com.br/sp8-2026?utm_source=trade-patrocinio&utm_medium=cpc&utm_campaign=trade-patrocinio-sp82026"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={bannerPatrocinador2026} alt="" />
          </a>
        </section>
        {/* <section className="in-baker">
          <a
            href="https://www.hellmanns.com.br/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={bgBaker} alt={bgBaker} />
          </a>
          <AdBanner />
        </section> */}
        {fase !== '2-encerrada' && (
          <section className="in-step">
            <div className="in-step-ctn">
              <div className="in-step-ctn-grid">
                <div className="in-step-ctn-grid-ctt" id="section-votacao">
                  <div className="in-step-ctn-grid-ctt-title">
                    <div className="in-step-ctn-grid-ctt-title-main">
                      <img
                        src={
                          fase.charAt(0) === '1'
                            ? iconStep1
                            : fase.charAt(0) === '2'
                              ? iconStep2
                              : iconStepAward
                        }
                        alt=""
                      />
                    </div>

                    {fase.charAt(0) !== '3' && (
                      <div className="in-step-ctn-grid-ctt-title-info">
                        {(fase.charAt(0) === '1' || fase === '2') && (
                          <>
                            <p>Onde estão as melhores pizzas de SP?</p>

                            <p>
                              Agora é a sua vez de votar nos estabelecimentos
                              que fazem as melhores pizzas de São Paulo. É hora
                              de apoiar suas pizzarias preferidas e ajudar a
                              decidir quem merece levar o título. Para dar
                              chance a mais pizzarias, procure dar seu voto para
                              pizzarias diferentes em cada categoria. Vamos
                              nessa?
                            </p>
                          </>
                        )}

                        {fase === '2-breve' && (
                          <p>
                            Muito obrigado a você que participou da fase 1 do
                            SP8 Pizza.
                            <br /> E nosso agradecimento e parabéns a todas as
                            pizzarias que se engajaram e motivaram
                            <br /> seus fregueses a votar. Estamos na fase de
                            apuração e validação dos votos.
                            <br /> Aguarde os finalistas e vote na fase 2, de 20
                            a 30 de junho.
                          </p>
                        )}
                      </div>
                    )}
                  </div>

                  {fase.charAt(0) === '1' && (
                    <div className="in-step-ctn-grid-ctt-cards">
                      <ul>
                        <li>
                          <Link to={fase === '1' && '/votacao/marguerita'}>
                            <div>
                              <div className="in-step-ctn-grid-ctt-cards-flip">
                                <div className="in-step-ctn-grid-ctt-cards-flip-front">
                                  <img
                                    src={imageMarguerita}
                                    alt={imageMarguerita}
                                  />
                                  <div>
                                    <p>Pizza Marguerita</p>
                                    {fase === '1' && (
                                      <button type="button">Vote Agora!</button>
                                    )}
                                  </div>
                                </div>

                                <div className="in-step-ctn-grid-ctt-cards-flip-back">
                                  <img src={imageFlip} alt={imageFlip} />
                                  <div>
                                    <p>Pizza Marguerita</p>
                                    <p>
                                      Com ingredientes simples e tradição
                                      centenária, a Marguerita representa a
                                      essência da pizza de origem italiana:
                                      molho de tomate, muçarela e manjericão
                                      fresco. É a prova de que menos é mais e
                                      exige técnica, equilíbrio e ingredientes
                                      de qualidade. Em São Paulo, muitas
                                      pizzarias se orgulham de preparar essa
                                      receita clássica como manda a tradição.
                                      Agora, queremos saber: qual é a pizzaria
                                      que entrega a melhor Pizza Marguerita da
                                      cidade? Vote na sua favorita!
                                    </p>
                                    {fase === '1' && (
                                      <button type="button">Vote Agora!</button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                        <li>
                          <Link to={fase === '1' && '/votacao/calabresa'}>
                            <div>
                              <div className="in-step-ctn-grid-ctt-cards-flip">
                                <div className="in-step-ctn-grid-ctt-cards-flip-front">
                                  <img
                                    src={imageCalabresa}
                                    alt={imageCalabresa}
                                  />
                                  <div>
                                    <p>Pizza de Calabresa</p>
                                    {fase === '1' && (
                                      <button type="button">Vote Agora!</button>
                                    )}
                                  </div>
                                </div>
                                <div className="in-step-ctn-grid-ctt-cards-flip-back">
                                  <img src={imageFlip} alt={imageFlip} />
                                  <div>
                                    <p>Pizza de Calabresa</p>
                                    <p>
                                      Com cebola ou sem cebola? Com queijo ou
                                      sem queijo? Não importa: o que é certo é
                                      que não dá para falar de pizza em São
                                      Paulo sem lembrar da pizza de calabresa.
                                      De tão popular, cada pizzaiolo dá seu
                                      toque especial ao preparo e é exatamente
                                      isso que buscamos descobrir. Qual é a
                                      pizzaria que faz a melhor Pizza de
                                      Calabresa da cidade? Vote e ajude a eleger
                                      a melhor!
                                    </p>
                                    {fase === '1' && (
                                      <button type="button">Vote Agora!</button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                        <li>
                          <Link to={fase === '1' && '/votacao/portuguesa'}>
                            <div>
                              <div className="in-step-ctn-grid-ctt-cards-flip">
                                <div className="in-step-ctn-grid-ctt-cards-flip-front">
                                  <img
                                    src={imagePortuguesa}
                                    alt={imagePortuguesa}
                                  />
                                  <div>
                                    <p>Pizza Portuguesa</p>
                                    {fase === '1' && (
                                      <button type="button">Vote Agora!</button>
                                    )}
                                  </div>
                                </div>
                                <div className="in-step-ctn-grid-ctt-cards-flip-back">
                                  <img src={imageFlip} alt={imageFlip} />
                                  <div>
                                    <p>Pizza Portuguesa</p>
                                    <p>
                                      Presunto, ovo, cebola, azeitona e queijo:
                                      a pizza portuguesa é aquela que reúne
                                      tradição e que conquista paladares com sua
                                      combinação de ingredientes. Um clássico
                                      das pizzarias paulistanas. Por isso, a
                                      disputa promete ser acirrada! Qual é a
                                      pizzaria que tem a melhor Pizza Portuguesa
                                      da cidade? Vote já!
                                    </p>
                                    {fase === '1' && (
                                      <button type="button">Vote Agora!</button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={
                              fase === '1' &&
                              '/votacao/melhor-pizzaria-sao-paulo'
                            }
                          >
                            <div>
                              <div className="in-step-ctn-grid-ctt-cards-flip">
                                <div className="in-step-ctn-grid-ctt-cards-flip-front">
                                  <img src={bgSpPizza} alt={bgSpPizza} />
                                  <div>
                                    <p>
                                      Melhor Pizzaria de <br /> São Paulo
                                    </p>
                                    {fase === '1' && (
                                      <button type="button">Vote Agora!</button>
                                    )}
                                  </div>
                                </div>

                                <div className="in-step-ctn-grid-ctt-cards-flip-back">
                                  <img src={imageFlip} alt={imageFlip} />
                                  <div>
                                    <p>Melhor Pizzaria de São Paulo</p>
                                    <p>
                                      Em São Paulo, a pizza vai muito além da
                                      receita: é tradição de família, encontro
                                      entre amigos e celebração de sabores. Cada
                                      paulistano tem a sua favorita.Agora é a
                                      hora de decidir: qual é a melhor pizzaria
                                      da cidade? Vote e participe dessa disputa
                                      deliciosa!
                                    </p>
                                    {fase === '1' && (
                                      <button type="button">Vote Agora!</button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={
                              fase === '1' &&
                              '/votacao/melhor-pizzaria-delivery'
                            }
                          >
                            <div>
                              <div className="in-step-ctn-grid-ctt-cards-flip">
                                <div className="in-step-ctn-grid-ctt-cards-flip-front">
                                  <img
                                    src={imageDelivery}
                                    alt={imageDelivery}
                                  />
                                  <div>
                                    <p>
                                      Melhor Pizzaria de <br /> Delivery
                                    </p>
                                    {fase === '1' && (
                                      <button type="button">Vote Agora!</button>
                                    )}
                                  </div>
                                </div>

                                <div className="in-step-ctn-grid-ctt-cards-flip-back">
                                  <img src={imageFlip} alt={imageFlip} />
                                  <div>
                                    <p>Melhor Pizzaria de Delivery</p>
                                    <p>
                                      Em casa ou no trabalho, o delivery de
                                      pizza vai muito além da praticidade: é o
                                      conforto do lar, a salvação do final de
                                      semana e aquela alegria que chega
                                      quentinha dentro da caixa. Todo mundo tem
                                      a sua pizzaria favorita salva no topo do
                                      aplicativo para os dias de preguiça ou de
                                      celebração. Agora é a hora de decidir:
                                      qual entrega conquista o seu coração e o
                                      seu paladar? Vote e participe dessa
                                      disputa deliciosa!
                                    </p>
                                    {fase === '1' && (
                                      <button type="button">Vote Agora!</button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  )}

                  {(fase === '2' || fase === '2-encerrada') && (
                    <div className="in-step-ctn-grid-ctt-cards" id="pizzarias">
                      <Tabs>
                        <TabList>
                          {Object.keys(pizzarias).map((key) => (
                            <Tab key={key} data-tab-key={key}>
                              {tab[key]}
                            </Tab>
                          ))}
                        </TabList>

                        {Object.keys(pizzarias).map((key) => (
                          <TabPanel key={key}>
                            <ul>
                              {pizzarias[key]?.map((item) => (
                                <li key={item.id}>
                                  <div className="in-step-ctn-grid-ctt-cards-flip">
                                    <div className="in-step-ctn-grid-ctt-cards-flip-front">
                                      <img
                                        src={item.imagem}
                                        alt={item.imagem}
                                      />
                                      <div>
                                        <p>{item.nome}</p>
                                        {fase === '2' && (
                                          <span
                                            onClick={() =>
                                              showVotacao(
                                                item.id,
                                                item.nome,
                                                tab[key]
                                              )
                                            }
                                          >
                                            Vote agora!
                                          </span>
                                        )}
                                        <Link to={`/pizzaria/${item.slug}`}>
                                          <span>ver detalhes</span>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </TabPanel>
                        ))}
                      </Tabs>
                    </div>
                  )}

                  {fase === '3' && (
                    <div
                      className="in-step-ctn-grid-ctt-result"
                      id="vencedores"
                    >
                      <div className="container">
                        <div className="ganhador-container">
                          <h3>Melhor Pizza de Calabressa</h3>

                          <div className="list-cards-ganhadores">
                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img src={imageNapoli} alt="Beco di Napoli" />
                              </div>

                              <div className="colocacao-ganhador">1º</div>

                              <div className="wrapper-nome-ganhador">
                                Beco di Napoli
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img
                                  src={imageSperanza}
                                  alt="Speranza Bela Vista"
                                />
                              </div>

                              <div className="colocacao-ganhador">2º</div>

                              <div className="wrapper-nome-ganhador">
                                Speranza Bela Vista
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img src={imageGattoffiga} alt="Gattofiga" />
                              </div>

                              <div className="colocacao-ganhador">3º</div>

                              <div className="wrapper-nome-ganhador">
                                Gattofiga
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="ganhador-container">
                          <h3>
                            Melhor Pizza de Marguerita{' '}
                            <span>
                              - apresentada por Catupiry® Profissional
                            </span>
                          </h3>

                          <div className="list-cards-ganhadores">
                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img src={imageMercutio} alt="Mercutio" />
                              </div>

                              <div className="colocacao-ganhador">1º</div>

                              <div className="wrapper-nome-ganhador">
                                Mercutio
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img src={imageVaranda} alt="Varanda 228" />
                              </div>

                              <div className="colocacao-ganhador">2º</div>

                              <div className="wrapper-nome-ganhador">
                                Varanda 228
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img src={imageGalpaozin} alt="Galpãozin" />
                              </div>

                              <div className="colocacao-ganhador">3º</div>

                              <div className="wrapper-nome-ganhador">
                                Galpãozin
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="ganhador-container">
                          <h3>Melhor Pizza de Portuguesa</h3>

                          <div className="list-cards-ganhadores">
                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img src={imageChena} alt="Pizza Chena" />
                              </div>

                              <div className="colocacao-ganhador">1º</div>

                              <div className="wrapper-nome-ganhador">
                                Pizza Chena
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img
                                  src={imageOli}
                                  alt="Oli Pizzas Artesanais"
                                />
                              </div>

                              <div className="colocacao-ganhador">2º</div>

                              <div className="wrapper-nome-ganhador">
                                Oli Pizzas Artesanais
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img
                                  src={imageQuintalVoMaria}
                                  alt="Quintal Vó Maria"
                                />
                              </div>

                              <div className="colocacao-ganhador">3º</div>

                              <div className="wrapper-nome-ganhador">
                                Quintal Vó Maria
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="ganhador-container">
                          <h3>Melhores Pizzarias - Regiões</h3>

                          <div className="list-cards-ganhadores variation-2">
                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img src={imageJullia} alt="Jullia" />
                              </div>

                              <div className="zona-ganhador">NORTE</div>

                              <div className="wrapper-nome-ganhador">
                                Jullia
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img src={imageChena} alt="Pizza Chena" />
                              </div>

                              <div className="zona-ganhador">SUL</div>

                              <div className="wrapper-nome-ganhador">
                                Pizza Chena
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img src={imageCasteloes} alt="Castelões" />
                              </div>

                              <div className="zona-ganhador">LESTE</div>

                              <div className="wrapper-nome-ganhador">
                                Castelões
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img src={imageVaranda} alt="Varanda 228" />
                              </div>

                              <div className="zona-ganhador">OESTE</div>

                              <div className="wrapper-nome-ganhador">
                                Varanda 228
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img
                                  src={imageVeridiana}
                                  alt="Veridiana Higienópolis"
                                />
                              </div>

                              <div className="zona-ganhador">CENTRAL</div>

                              <div className="wrapper-nome-ganhador">
                                Veridiana Higienópolis
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="ganhador-container">
                          <h3>Melhor Pizzaria de São Paulo</h3>

                          <div className="list-cards-ganhadores">
                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img src={imageVaranda} alt="Varanda 228" />
                              </div>

                              <div className="colocacao-ganhador">1º</div>

                              <div className="wrapper-nome-ganhador">
                                Varanda 228
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img src={imageMercutio} alt="Mercutio" />
                              </div>

                              <div className="colocacao-ganhador">2º</div>

                              <div className="wrapper-nome-ganhador">
                                Mercutio
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img
                                  src={imageVeridiana}
                                  alt="Veridiana Higienópolis"
                                />
                              </div>

                              <div className="colocacao-ganhador">3º</div>

                              <div className="wrapper-nome-ganhador">
                                Veridiana Higienópolis
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="ganhador-container">
                          <h3>Melhor Pizzaria de Delivery</h3>

                          <div className="list-cards-ganhadores">
                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img
                                  src={imageRemanso}
                                  alt="Pizzaria Remanso"
                                />
                              </div>

                              <div className="colocacao-ganhador">1º</div>

                              <div className="wrapper-nome-ganhador">
                                Remanso
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img
                                  src={imageRRBrasil}
                                  alt="Pizzaria RR Brasil"
                                />
                              </div>

                              <div className="colocacao-ganhador">2º</div>

                              <div className="wrapper-nome-ganhador">
                                RR Brasil
                              </div>
                            </div>

                            <div className="single-card-ganhador">
                              <div className="card-ganhador-image">
                                <img src={imageKrostinas} alt="Krosttina's" />
                              </div>

                              <div className="colocacao-ganhador">3º</div>

                              <div className="wrapper-nome-ganhador">
                                Krosttina's
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        )}

        {/* <section className="in-banner-container">
          <div>
            <Swiper
              navigation
              modules={[Navigation, Autoplay]}
              className="slider-patrocinadores"
              loop
              autoplay={{
                delay: 10000
              }}
            >
              <SwiperSlide>
                <a
                  href="https://www.searafoodsolutions.com.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={bannerSeara} alt="Banner Seara" />
                </a>
              </SwiperSlide>
              <SwiperSlide>
                <a
                  href="https://www.nestleprofessional.com.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={bannerNestle} alt="Banner Nestle" />
                </a>
              </SwiperSlide>
            </Swiper>
          </div>
        </section> */}

        <section className="section-banner">
          <img src={bannerPizza} alt="" />
        </section>

        <section className="in-whatis">
          <div className="in-whatis-ctn">
            <div className="in-whatis-ctn-grid">
              <div className="in-whatis-ctn-grid-lf">
                <div className="row-one">
                  <p className="title">QUEM SOMOS</p>

                  <p className="single-text">
                    Criada pelo jornalista Miguel Icassatti e pelo chef Eduardo
                    Maya, os mesmos idealizadores do concurso Padocaria-SP, a
                    SP8 Pizza é uma premiação independente, que tem por objetivo
                    valorizar as Pizzarias de São Paulo. Por meio do voto
                    popular e de um júri técnico, o SP8 busca conectar as
                    pizzarias, o público consumidor e os setores da indústria
                    que suprem os estabelecimentos com insumos e equipamentos.
                  </p>
                </div>

                <div className="row-two">
                  <p className="subtitle">Independência</p>

                  <p className="single-text">
                    É preciso deixar claro: SP8 Pizza é uma competição
                    independente e aberta à participação de todas as pizzarias
                    estabelecidas na cidade de São Paulo. A ação é financiada
                    por patrocinadores e com apoio e parceria de meios de
                    comunicação: ou seja, o SP8 Pizza não recebe nenhum recurso
                    vindo das pizzarias ou de estabelecimentos que venham a ser
                    indicados. Portanto, nenhum estabelecimento está autorizado
                    a pedir nenhum recurso ou benesse em nome do SP8 Pizza e/ou
                    de seus curadores.
                  </p>
                </div>

                <div className="folha">
                  <img src={folha} alt="" />
                </div>
              </div>

              <div className="in-whatis-ctn-grid-rt">
                <div className="wrapper-title-and-icon">
                  <p>São Paulo é a capital nacional da pizza.</p>

                  <img src={iconFatiaPizza} alt={iconFatiaPizza} />
                </div>

                <ul className="list-itens">
                  <li>
                    <div className="red">
                      <span>›</span>
                    </div>
                    <p>
                      <span className="bold">83.OOO</span> pizzarias no Brasil *
                    </p>
                  </li>
                  <li>
                    <div className="red">
                      <span>›</span>
                    </div>
                    <p>
                      <span className="bold">26.OOO</span> pizzarias no estado
                      de São Paulo *
                    </p>
                  </li>
                  <li>
                    <div className="red">
                      <span>›</span>
                    </div>
                    <p>
                      <span className="bold">5.OOO</span> pizzarias na cidade de
                      São Paulo **
                    </p>
                  </li>
                  <li>
                    <div className="red">
                      <span>›</span>
                    </div>
                    <p>
                      <span className="bold">572.OOO</span> pizzas são
                      produzidas por dia em São Paulo**
                    </p>
                  </li>
                </ul>

                <p className="fonts">
                  * Apubra (Associação Pizzarias Unidas do Brasil)
                  <br />
                  ** ECD Food Service
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="section-instagram">
          <h2 className="title">Fique por dentro</h2>
          <h3 className="subtitle">
            O que Estamos Compartilhando nas Redes Sociais
          </h3>

          <div className="grid-instagram-posts">
            {instagramItems.map((item) => {
              return (
                <a
                  key={item.id}
                  href={item.permalink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="single-item-grid-instagram"
                >
                  {item.media_type === 'VIDEO' ? (
                    <video
                      src={item.media_url}
                      controls
                      muted
                      playsInline
                      style={{ width: '100%', height: 'auto' }}
                    />
                  ) : (
                    <img src={item.media_url} alt="" />
                  )}
                </a>
              );
            })}
          </div>
        </section>

        <section className="in-partiners">
          <div className="in-partiners-ctn">
            <div className="in-partiners-ctn-grid">
              <div className="in-partiners-ctn-grid-logo">
                <img src={logoCor2026} alt={logoCor2026} />
              </div>
            </div>
          </div>
        </section>

        <section className="in-footer">
          <div className="in-footer-ctn">
            <div className="in-footer-ctn-grid">
              <p>
                Copyright - 2025 | Todos os direitos reservados -{' '}
                <Link to="/lgpd">Política de privacidade</Link> |{' '}
                <Link to="/termos-de-uso">Termos de uso</Link> |{' '}
                <span onClick={() => setShowRegulamento(true)}>
                  Regulamento
                </span>
              </p>
              <a
                href="https://www.olivas.digital/"
                rel="noreferrer"
                target="_blank"
              >
                <img src={logoOlivasDigital} alt={logoOlivasDigital} />
              </a>
            </div>
          </div>
        </section>
      </section>
      {/* seção principal */}
    </>
  );
};

export default Home;
